import axios from "axios";

export const uploadToCloudinary = async (file: File) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const uploadPreset = import.meta.env.VITE_LIVE_CLOUDINARY_PRESET;
    if (!uploadPreset) {
      throw new Error("VITE_LIVE_CLOUDINARY_PRESET is not defined");
    }

    formData.append("upload_preset", uploadPreset);

    const cloudinaryURL = import.meta.env.VITE_LIVE_CLOUDINARY_URL;
    if (!cloudinaryURL) {
      throw new Error("VITE_LIVE_CLOUDINARY_URL is not defined");
    }

    const response = await axios.post(cloudinaryURL, formData);
    return response.data.secure_url;
  } catch (error) {
    console.error("Error uploading photo: ", error);
    throw error;
  }
};
